import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import { AppRoutes } from "@/infra/router";

const AccountSettingsPage = lazy(() => import("./AccountSettingsPage"));
const LanguageSettingsPage = lazy(() => import("./LanguageSettingsPage"));
const NotificationSettingsPage = lazy(() => import("./NotificationSettingsPage"));
const CoachSettingsPage = lazy(() => import("./CoachSettingsPage"));
const SoundSettingsPage = lazy(() => import("./SoundSettingsPage"));
const DataTransparencySettingsPage = lazy(() => import("./DataTransparencySettingsPage"));
const TermsAndConditionsSettingsPage = lazy(() => import("./TermsAndConditionsSettingsPage"));
const IFUSettingsPage = lazy(() => import("./IFUSettingsPage"));
const ReleaseNotesPage = lazy(() => import("./ReleaseNotesPage"));

export const settingsRoutes = [
  <Route
    key={AppRoutes.Settings}
    element={<Navigate replace to={AppRoutes.AccountSettings} />}
    path={AppRoutes.Settings}
  />,
  <Route
    key={AppRoutes.AccountSettings}
    path={AppRoutes.AccountSettings}
    element={<AccountSettingsPage />}
  />,

  <Route
    key={AppRoutes.LanguageSettings}
    path={AppRoutes.LanguageSettings}
    element={<LanguageSettingsPage />}
  />,
  <Route
    key={AppRoutes.NotificationSettings}
    path={AppRoutes.NotificationSettings}
    element={<NotificationSettingsPage />}
  />,
  <Route
    key={AppRoutes.CoachSettings}
    path={AppRoutes.CoachSettings}
    element={<CoachSettingsPage />}
  />,
  <Route
    key={AppRoutes.SoundSettings}
    path={AppRoutes.SoundSettings}
    element={<SoundSettingsPage />}
  />,
  <Route
    key={AppRoutes.PrivacyPolicyAndDataTransparencySettings}
    path={AppRoutes.PrivacyPolicyAndDataTransparencySettings}
    element={<DataTransparencySettingsPage />}
  />,
  <Route
    key={AppRoutes.TermsAndConditionsSettings}
    path={AppRoutes.TermsAndConditionsSettings}
    element={<TermsAndConditionsSettingsPage />}
  />,
  <Route
    key={AppRoutes.IFUSettings}
    path={AppRoutes.IFUSettings}
    element={<IFUSettingsPage />}
  />,
  <Route
    key={AppRoutes.ReleaseNotes}
    path={AppRoutes.ReleaseNotes}
    element={<ReleaseNotesPage />}
  />,
];
